




import { Component, Mixins } from "vue-property-decorator";
import { TextureKinds } from "../../domain/drawing";
import OptionDropDownSelector from "../system/selectors/OptionDropDownSelector.vue";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class TextureKindDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  data(): any {
    return {
      options: [
        new StandardOption<TextureKinds>("なし", TextureKinds.None),
        new StandardOption<TextureKinds>("灰網掛け", TextureKinds.GrayDiagonalCross),
        new StandardOption<TextureKinds>("塗りつぶし", TextureKinds.Fill),
        new StandardOption<TextureKinds>("斜線(左上→右下)", TextureKinds.LinesFromTopLeft),
        new StandardOption<TextureKinds>("斜線(右上→左下)", TextureKinds.LinesFromTopRight),
        new StandardOption<TextureKinds>("小さな点", TextureKinds.SmallDot),
        new StandardOption<TextureKinds>("大きな点", TextureKinds.LargeDot),
        new StandardOption<TextureKinds>("縦縞", TextureKinds.LinesFromTop),
        new StandardOption<TextureKinds>("横縞", TextureKinds.LinesFromLeft),
        new StandardOption<TextureKinds>("斜線交差", TextureKinds.DiagonalCross),
        new StandardOption<TextureKinds>("縦横交差", TextureKinds.Cross),
      ],
    };
  }
}
